import { LoadableRoute } from 'routes/utils/loadable';

export const ClientsContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "Clients" */ './Clients'),
});
